import { HeaderSection } from "src/app/shared/models/data/documentTemplate";

export const DEFAULT_HEADER: HeaderSection = {
    topSection: {
        fields: {
            to: {
                label: "quotation.to",
                type: "string",
                value: "",
                editable: true,
                required: true,
                hideable: false,
                hidden: false
            },
            from: {
                label: "quotation.from",
                type: "string",
                value: "",
                editable: true,
                required: true,
                hideable: false,
                hidden: false
            },
            company: {
                label: "quotation.company",
                type: "string",
                value: "",
                editable: true,
                required: true,
                hideable: false,
                hidden: false
            },
            phone: {
                label: "quotation.phone",
                type: "string",
                value: "",
                editable: true,
                required: true,
                hideable: false,
                hidden: false
            },
            date: {
                label: "quotation.date",
                type: "date",
                value: "",
                editable: true,
                required: true,
                hideable: false,
                hidden: false
            },
            email: {
                label: "quotation.email",
                type: "string",
                value: "",
                editable: true,
                required: true,
                hideable: false,
                hidden: false
            },
            appendices: {
                label: "quotation.appendices",
                type: "string",
                value: "",
                editable: true,
                required: false,
                hideable: false,
                hidden: false
            },
            pages: {
                label: "quotation.pages",
                type: "integer",
                value: "",
                editable: false,
                required: false,
                hideable: false,
                hidden: true
            }
        }
    },
    middleSection: {
        fields: {
            your_ref: {
                label: "quotation.your_ref",
                type: "string",
                value: "",
                editable: true,
                required: true,
                hideable: false,
                hidden: false
            },
            our_offer_no: {
                label: "quotation.our_offer_no",
                type: "string",
                value: "",
                editable: false,
                required: true,
                hideable: false,
                hidden: false
            },
            destination: {
                label: "quotation.destination",
                type: "string",
                value: "",
                editable: true,
                required: false,
                hideable: true,
                hidden: false
            }
        }
    },
    bottomSection: {
        isModified: false
    }
};
